type NavigationState = {
  openedNavigationDropDownId: string | null;
  mobileDrawerOpen: boolean;
};
// TODO: close on navigation (middleware)
export function useNavigation() {
  const navigationState = useState<NavigationState>("layoutNavigation", () => ({
    openedNavigationDropDownId: null,
    mobileDrawerOpen: false,
  }));

  const closeAll = () => {
    document.body.style.overflow = "auto";
    navigationState.value.mobileDrawerOpen = false;
    navigationState.value.openedNavigationDropDownId = null;
  };

  const toggleMobileDrawer = () => {
    navigationState.value.mobileDrawerOpen =
      !navigationState.value.mobileDrawerOpen;
  };

  const toggleSubMenu = (id: string | null) => {
    navigationState.value.openedNavigationDropDownId =
      navigationState.value.openedNavigationDropDownId === id ? null : id;
  };

  return {
    navigationState,
    toggleMobileDrawer,
    toggleSubMenu,
    closeAll,
  };
}
